// Module
var code = "<div v-if=\"data\" :id=\"vegaid\"></div>\n";
// Exports
module.exports = code;